var types = {
	MessageId: "[u8;32]",
	Payload: "Vec<u8>",
	Value: "Compact<u128>",
	Dispatch: {
		kind: "DispatchKind",
		message: "Message"
	},
	DispatchKind: {
		_enum: [
			"Init",
			"Handle",
			"Reply",
			"Signal"
		]
	},
	Reason: {
		_enum: {
			"Error": "Null",
			ValueTransfer: "Null",
			Dispatch: "Vec<u8>"
		}
	},
	DispatchOutcome: {
		message_id: "H256",
		outcome: "ExecutionResult"
	},
	MessageInfo: {
		message_id: "H256",
		program_id: "H256",
		origin: "H256"
	},
	UserStoredMessage: {
		id: "MessageId",
		source: "ProgramId",
		destination: "ProgramId",
		payload: "Payload",
		value: "Value"
	},
	Interval: {
		start: "u32",
		finish: "u32"
	}
};
var typesMessage = {
	types: types
};

export { typesMessage as default, types };
